import React from "react";

/**
 * props
 *  - inputType
 *  - String valText
 *  - Boolean editMode
 *  - String fieldName
 *  - String labelText
 *  - function handleChange
 *  - String compareVal (if comparing a password and password confirmation, compareVal and valText should match)
 *  - Boolean textBox True if the input should be a textarea box instead of a test input.
 *  - integer maxLength The maximum string length (in characters) to accept as input
 **/
const TextInput = (props) => {
  /**True unless doing a password comparison**/
  const passComparison = props.compareVal
    ? props.compareVal == props.valText
    : true;
  /**If a maximum input length is provided, this character counter is added below the input element**/
  const characters_used_counter =
    props.maxLength && props.valText ? (
      <small className="text-muted pt-0 mt-0 text-small">
        Used {props.valText.length} of {props.maxLength} Characters.
      </small>
    ) : null;
  /**If this is a required field, shows a red asterisk next to the label**/
  const required_span = props.required ? (
    <span className="text-danger font-weight-bold">*</span>
  ) : (
    ""
  );

  return props.editMode ? (
    <fieldset className="pt-3">
      <label className="pr-1" htmlFor={props.fieldName}>
        {props.labelText} {required_span}
      </label>
      {props.textBox ? (
        <textarea
          id={props.fieldName}
          className={passComparison ? "col-12 block" : "col-12 bg-danger"}
          name={"user[" + props.fieldName + "]"}
          value={props.valText ? props.valText : ""}
          onChange={(e) => props.handleChange(props.fieldName, e)}
          maxLength={props.maxLength}
        />
      ) : (
        <input
          id={props.fieldName}
          className={passComparison ? "" : "bg-danger"}
          type={props.inputType || "text"}
          name={"user[" + props.fieldName + "]"}
          value={props.valText ? props.valText : ""}
          onChange={(e) => props.handleChange(props.fieldName, e)}
          maxLength={props.maxLength}
        />
      )}
      {characters_used_counter}
    </fieldset>
  ) : (
    <div>
      <label htmlFor={props.fieldName}>{props.labelText}</label>
      <div id={props.fieldName} className="card inner-buffer">
        {props.valText ? props.valText : ""}
      </div>
    </div>
  );
};

export default TextInput;
